import './MainButton.css'

interface MainButtonProps {
    text: string;
    onClick?: () => void;
    type?: 'button' | 'submit' | 'reset';
    buttonStyles?: React.CSSProperties;
}

const MainButton = ({ text, onClick, type = 'button', buttonStyles }: MainButtonProps) => {
    return (
        <button 
            className="main-button" 
            onClick={onClick} 
            type={type} 
            style={buttonStyles}
        >
            <span className="button-text">{text}</span>
        </button>
    );
};

export default MainButton;